import React from 'react';
import Banner from "../../Assets/Blog/BlogBanner.png";

const CommonBanner = ({ backgroundImage = Banner, title = "", subheading = "" }) => {
    return (
        <div data-aos="fade-up" data-aos-duration="1000"
            style={{ backgroundImage: `url(${backgroundImage})` }}
            className="bg-cover bg-center w-full h-[20rem] top-0 flex items-center justify-start relative "
        >
            {/* Overlay */}
            {/* <div className="absolute inset-0 bg-black/30 bg-opacity-30"></div> */}

            {/* Title Only - Centered */}
            <div className="relative max-w-[1400px] mx-auto w-full z-10 text-start px-6">
                <h1 className="text-4xl font-semibold text-white">
                    {title}
                </h1>
                <p className='text-[1rem] pt-4 font-medium text-white'>
                    {subheading}
                </p>
            </div>
        </div>
    );
};

export default CommonBanner;